import { isEmpty, path, pathOr } from 'ramda'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Guard from '@/app/component/guard/auth'
import { CATI_USER_ROLE } from '@/app/module/cati/definitions'
import { switchOrganization } from '@/app/module/user/store/actions'
import {
  selectActiveOrg,
  selectOrgId,
  selectUserOrganizations,
  selectUserRole,
} from '@/app/module/user/store/selectors'

import Header from './component/header'
import { selectToken } from './store/selectors'
import {
  logoutUser,
  selectIsReauthEligible,
  selectReauthUsername,
  selectSessionLoading,
  selectTrialMode,
} from './store/session.slice'

const guardSelector = ({ campaignItem, session, user, plans }) => ({
  activeOrg: selectActiveOrg({ user }),
  error: user.details.error,
  loading:
    selectSessionLoading({ session }) ||
    pathOr(false, ['details', 'loading'], user) ||
    pathOr(false, ['item', 'loading'], plans),
  isReauthEligible: selectIsReauthEligible({ campaignItem }),
  isReauthRequired: !!selectReauthUsername({ session }),
  isAuthorized: !!selectToken() && !isEmpty(user.details.data),
  isCATIUser: selectUserRole({ user }) === CATI_USER_ROLE,
  trialMode: selectTrialMode({ session }),
  planId: path(['item', 'data', 'planId'], plans),
  role: selectUserRole({ user }),
})

export const AuthGuard = connect(guardSelector)(Guard)

const headerSelector = ({ session, user, plans }) => ({
  token: selectToken(),
  orgId: selectOrgId({ user }),
  activeOrg: selectActiveOrg({ user }),
  email: path(['details', 'data', 'username'], user),
  organizations: selectUserOrganizations({ user }),
  trialMode: selectTrialMode({ session }),
  planId: path(['item', 'data', 'planId'], plans),
  role: selectUserRole({ user }),
})

const headerDispatcher = (dispatch) => bindActionCreators({ logout: logoutUser, switchOrganization }, dispatch)

export const AuthHeader = connect(headerSelector, headerDispatcher)(Header)
